import type { Template } from "@/types";

export const PO_03_H2_V1: Template[] = [
{
    id: "po-03-h2v2-01",
    name: "PO 01 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 0, y: 225, width: 484, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 492, y: 225, width: 235, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 225, width: 482, height: 402, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h2v2-02",
    name: "PO 02 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 53, y: 244, width: 439, height: 365, rotation: 0, imageRotation: 0 },
        { id: "2", x: 500, y: 244, width: 216, height: 365, rotation: 0, imageRotation: 0 },
        { id: "3", x: 724, y: 244, width: 437, height: 365, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-03",
    name: "PO 03 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [ 
        { id: "1", x: 0, y: 225, width: 483, height: 402, rotation: 0, imageRotation: 0 },
        { id: "2", x: 491, y: 225, width: 482, height: 402, rotation: 0, imageRotation: 0 },
        { id: "3", x: 981, y: 225, width: 237, height: 402, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-03-h2v2-04",
    name: "PO 04 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 100, y: 155, width: 755, height: 521, rotation: 0, imageRotation: 0 },
        { id: "2", x: 863, y: 519, width: 226, height: 157, rotation: 0, imageRotation: 0 },
        { id: "3", x: 863, y: 155, width: 226, height: 356, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-05",
    name: "PO 05 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 174, y: 103, width: 444, height: 319, rotation: 0, imageRotation: 0 },
        { id: "2", x: 174, y: 430, width: 444, height: 318, rotation: 0, imageRotation: 0 },
        { id: "3", x: 626, y: 103, width: 414, height: 644, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-06",
    name: "PO 06 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 83, y: 103, width: 444, height: 319, rotation: 0, imageRotation: 0 },
        { id: "2", x: 83, y: 430, width: 444, height: 318, rotation: 0, imageRotation: 0 },
        { id: "3", x: 706, y: 103, width: 414, height: 645, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-03-h2v2-07",
    name: "PO 07 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 57, y: 67, width: 493, height: 355, rotation: 0, imageRotation: 0 },
        { id: "2", x: 57, y: 430, width: 493, height: 355, rotation: 0, imageRotation: 0 },
        { id: "3", x: 683, y: 67, width: 461, height: 718, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-08",
    name: "PO 08 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 97, y: 103, width: 414, height: 645, rotation: 0, imageRotation: 0 },
        { id: "2", x: 691, y: 103, width: 444, height: 319, rotation: 0, imageRotation: 0 },
        { id: "3", x: 691, y: 430, width: 444, height: 318, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-09",
    name: "PO 09 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 225, width: 237, height: 402, rotation: 0, imageRotation: 0 },
        { id: "2", x: 245, y: 225, width: 482, height: 402, rotation: 0, imageRotation: 0 },
        { id: "3", x: 735, y: 225, width: 482, height: 402, rotation: 0, imageRotation: 0 }
    ],
}
];